import { render, staticRenderFns } from "./GlobalUploader.vue?vue&type=template&id=19033c94&scoped=true"
import script from "./GlobalUploader.vue?vue&type=script&lang=js"
export * from "./GlobalUploader.vue?vue&type=script&lang=js"
import style0 from "./GlobalUploader.vue?vue&type=style&index=0&id=19033c94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19033c94",
  null
  
)

export default component.exports